import { render, staticRenderFns } from "./RecommendUserForProjectsLayer.vue?vue&type=template&id=a01e5ff6&scoped=true"
import script from "./RecommendUserForProjectsLayer.vue?vue&type=script&lang=ts"
export * from "./RecommendUserForProjectsLayer.vue?vue&type=script&lang=ts"
import style0 from "./RecommendUserForProjectsLayer.vue?vue&type=style&index=0&id=a01e5ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01e5ff6",
  null
  
)

export default component.exports